import { withCaptchaLogic } from "../enhancers/withCaptchaLogic";
import { CaptchaInput as _CaptchaInput } from "./CaptchaInput";
export var CaptchaInput = withCaptchaLogic(_CaptchaInput);